export default __webpack_public_path__ + "images/C4.27b6cba.png";